import React, { useEffect, useState } from "react";
import { Offcanvas, Dropdown, Button, Spinner } from "react-bootstrap";
import CustomButton from "../../common/CustomButton.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import { Plus, ChevronLeft, ChevronRight, Calendar, Clock } from "lucide-react";
import CommonDropdown from "../../common/common_dropDown.jsx";
import { getVehicleAssignmentEditApi, getVehicleDetailApi, createAssignmentApi, updateAssignmentApi } from "./assignment-api.js";
import DOMPurify from "dompurify";
import ErrorExtractor from "../../common/error_extractor.jsx";
import { useNavigate } from "react-router-dom";
const VehicleAssignmentForm = ({ id, show, handleClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [startDate, setStartDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [isLoader, setIsLoader] = useState(false);

  const [selectedAssignTo, setSelectedAssignTo] = useState(null);
  const [selectedLicensePlate, setSelectedLicensePlate] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [vinValue, setVinValue] = useState("");
  const [type, setType] = useState("");
  const [groupLocation, setGroupLocation] = useState("");
  const [kilometerDrive, setKilometerDrive] = useState("");

  const handleTimeChange = (value) => {
    setStartTime(value);
  };
  const handleEndTimeChange = (value) => {
    if (endDate && startDate && endDate.toDateString() === startDate.toDateString()) {
      if (value < startTime) {
        // Option 1: force the value to startTime if user enters smaller
        setEndTime(startTime);

        setErrorMsg({
          vehicle_id: "",
          assignee_id: "",
          start_date: "",
          start_time: "",
          end_date: "",
          end_time: "End time cannot be earlier than start time on the same day",
        });
        return;
      }
    }

    setEndTime(value);
    setErrorMsg((prev) => ({ ...prev, end_time: "" })); // clear error if valid
  };

  useEffect(() => {
    console.log("ss->", id);
    if (id != null) {
      getVehicleAssiDetails();
    }
  }, [id]);

  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    assignee_id: "",

    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
  });
  const handleSelectVin = (item) => {
    console.log("Selected:", item);
    setSelectedLicensePlate(item); // store selected id
  };
  const handleSelectAssign = (item) => {
    console.log("Selected:", item);
    setSelectedAssignTo(item); // store selected id
  };
  useEffect(() => {}, []);
  useEffect(() => {
    getVehicleDetails();
  }, [selectedLicensePlate]); //
  const getVehicleDetails = async () => {
    try {
      if (!selectedLicensePlate?.value) return; // safety check

      const response = await getVehicleDetailApi(selectedLicensePlate.value);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle;
        setVehicleName(vehicleData.name);
        setVinValue(vehicleData.vin);
        setGroupLocation(vehicleData.group_location);
        setType(vehicleData.vehicle_type);
        setKilometerDrive(vehicleData.kilometer_driven);
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  const getVehicleAssiDetails = async () => {
    try {
      const response = await getVehicleAssignmentEditApi(id);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle_assignment;
        setVehicleName(vehicleData.name);
        setVinValue(vehicleData.vin);
        setGroupLocation(vehicleData.group);
        setType(vehicleData.type);
        setKilometerDrive(vehicleData.km);
        setSelectedLicensePlate({
          value: vehicleData.vehicle_id,
          label: vehicleData.lic_no,
        });

        setSelectedAssignTo({
          value: vehicleData.assigned_to,
          label: vehicleData.user,
        });
        setEndDate(parseDate(vehicleData.end_date));
        setEndTime(parseTime(vehicleData.end_time));
        setStartDate(parseDate(vehicleData.start_date));
        setStartTime(parseTime(vehicleData.start_time));
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  // submit fucntion
  // Function to format date as "YYYY-MM-DD"
  function parseTime(timeString) {
    if (!timeString) return "";

    const timePattern = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
    const match = timeString.match(timePattern);

    if (!match) {
      console.warn("Invalid time format");
      return "";
    }

    let [_, hourStr, minuteStr, ampm] = match;
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    if (ampm.toUpperCase() === "PM" && hour < 12) hour += 12;
    if (ampm.toUpperCase() === "AM" && hour === 12) hour = 0;

    return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
  }
  function parseDate(dateString) {
    if (!dateString) return null;

    const [year, month, day] = dateString.split("-").map(Number);

    if (isNaN(year) || isNaN(month) || isNaN(day) || month < 1 || month > 12 || day < 1 || day > 31) {
      console.warn("Invalid date format");
      return null;
    }

    return new Date(year, month - 1, day); // JS months are 0-indexed
  }

  function formatDate(dateString) {
    if (!dateString) {
      console.warn("Invalid date input");
      return "";
    }

    const dateObj = new Date(dateString);

    if (isNaN(dateObj.getTime())) {
      console.warn("Invalid date format");
      return "";
    }

    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  // Function to format time from "HH:mm" to "hh:mm AM/PM"
  function formatTime(timeString) {
    if (!timeString) {
      console.warn("Invalid time input");
      return "";
    }

    const parts = timeString.split(":");
    if (parts.length !== 2) {
      console.warn("Invalid time format");
      return "";
    }

    const [hourStr, minuteStr] = parts;
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr;

    if (isNaN(hour) || isNaN(parseInt(minute, 10))) {
      console.warn("Time contains invalid numbers");
      return "";
    }

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    return `${hour.toString().padStart(2, "0")}:${minute} ${ampm}`;
  }
  const resetForm = () => {
    setSelectedLicensePlate(null);
    setSelectedAssignTo(null);
    setVehicleName("");
    setVinValue("");
    setType("");
    setGroupLocation("");
    setKilometerDrive("");
    setStartDate(null);
    setStartTime(null);
    setEndDate(null);
    setEndTime(null);
    setErrorMsg({
      vehicle_id: "",
      assignee_id: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
    });
  };

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        vehicle_id: selectedLicensePlate?.value ?? "",
        assignee_id: selectedAssignTo?.value ?? "",
        start_date: formatDate(startDate),
        start_time: formatTime(startTime),
        end_date: formatDate(endDate),
        end_time: formatTime(endTime),
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      let response;
      if (id == null) {
        response = await createAssignmentApi(sanitizedData);
      } else {
        response = await updateAssignmentApi(sanitizedData, id);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {};
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        handleClose(response);
        resetForm();
      }

      return response.data;
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const handleCloseWithReset = () => {
    resetForm(); // Reset form state
    handleClose(); // Close the Offcanvas
  };

  return (
    <Offcanvas show={show} onHide={handleCloseWithReset} placement="end">
      <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center">
        <Offcanvas.Title> {id !== null ? "Edit" : "New"} Vehicle assignment</Offcanvas.Title>
        <button
          onClick={handleCloseWithReset}
          style={{
            backgroundColor: "transparent",
            border: "2px solid #D4DDE7",
            color: "#172B4D",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          X
        </button>
      </Offcanvas.Header>
      <hr />
      <Offcanvas.Body>
        <div className="row">
          <div className="col-12">
            <label htmlFor="vin" className="form-label fw-400">
              License Plate *
            </label>
            <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select license  plate" value={selectedLicensePlate} onSelect={handleSelectVin} /> <span className="error-text">{errorMsg.vehicle_id}</span>
          </div>
          <div className="col-xl-6 mt-3">
            <label htmlFor="fill" className="form-label  fw-400">
              Vehicle name
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="vehicle name"
              value={vehicleName}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6 mt-3">
            <label htmlFor="plate" className="form-label  fw-400">
              Vehicle Identification Number (VIN)
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              value={vinValue}
              placeholder="Vin"
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400 mt-3">
              Type
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="Type"
              value={type}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400 mt-3">
              Group
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="Group"
              value={groupLocation}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6 mt-3">
            <label htmlFor="kmd" className="form-label  fw-400">
              Kilometer Driven
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="kilometer Driven"
              value={kilometerDrive}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6 mt-3">
            <label htmlFor="type" className="form-label fw-400 ">
              Assigned To
            </label>
            <CommonDropdown apiUrl={`${apiUrl}get_unassigned_drivers`} placeholder="Select assignee" value={selectedAssignTo} onSelect={handleSelectAssign} /> <span className="error-text">{errorMsg.assignee_id}</span>
          </div>
          <div className="col-xl-6 d-flex flex-row gap-1">
            <div className="col-xl-6 d-flex flex-column mt-3">
              <label htmlFor="date" className="form-label fw-400">
                Start Date
              </label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="yyyy-MM-dd"
                customInput={
                  <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {startDate ? startDate.toLocaleDateString() : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                    <Calendar size={16} />
                  </button>
                }
              />
              <span className="error-text">{errorMsg.start_date}</span>
            </div>
            <div className="col-xl-6 d-flex flex-column mt-3">
              <label htmlFor="time" className="form-label fw-400">
                Start Time
              </label>
              <input type="time" value={startTime} onChange={(e) => handleTimeChange(e.target.value)} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-10" /> <span className="error-text">{errorMsg.start_time}</span>
            </div>
          </div>

          <div className="col-xl-6 d-flex flex-row gap-1">
            <div className="col-xl-6 d-flex flex-column mt-3">
              <label htmlFor="date" className="form-label fw-400">
                End Date
              </label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="yyyy-MM-dd"
                minDate={startDate} // ✅ End date cannot be before start date
                customInput={
                  <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {endDate ? endDate.toLocaleDateString() : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                    <Calendar size={16} />
                  </button>
                }
              />
              <span className="error-text">{errorMsg.end_date}</span>{" "}
            </div>
            <div className="col-xl-6 d-flex flex-column mt-3">
              <label htmlFor="time" className="form-label fw-400">
                End Time
              </label>
              <input type="time" value={endTime} onChange={(e) => handleEndTimeChange(e.target.value)} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-10" />
              <span className="error-text">{errorMsg.end_time}</span>{" "}
            </div>
          </div>
          <div className="d-flex gap-3 justify-content-end mt-5">
            <CustomButton variant="custom" size="md" onClick={handleCloseWithReset} borderRadius="8px" border={true} bgColor="#FFFFFF" textColor="#172B4D" borderColor="#D4DDE7">
              Cancel
            </CustomButton>
            <CustomButton variant="custom" size="md" onClick={submitForm} borderRadius="8px" isLoading={isLoader} width="100px" bgColor="#471070" textColor="#FFFFFF">
              {id !== null ? "Update" : "Save"}
            </CustomButton>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default VehicleAssignmentForm;
